import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Theme } from "./Other/Types";
import { setCurrentTheme } from "./Other/Utils";

declare global {
  interface Window {
    applyTheme: (theme: Theme) => void;
  }
}

window.applyTheme = (theme: Theme) => {
  setCurrentTheme(theme);
  window.location.reload();
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
